import {
  CAN_NAVIGATE_TO,
  CURRENT_ROUTE,
  CUSTOM_EVENT,
  getGlobal,
  IS_INITD,
  makeGlobal,
  TABBAR,
  onBTDeviceFound,
  onScreenRecord,
  onKeyboardHeightChange
} from 'src/shared';
import { subscribe, publish } from './bridges';
import { IAnyStrObject } from 'src/types';

export function init() {
  // already initd
  if (getGlobal(IS_INITD) as boolean) {
    return;
  }

  makeGlobal(IS_INITD, true);
  try {
    // 增加蓝牙监听
    onBTDeviceFound();
    onScreenRecord();
    // 增加键盘高低变化监听
    onKeyboardHeightChange();
    subscribe(CUSTOM_EVENT.GET_CURRENT_ROUTE, (data: IAnyStrObject) => {
      makeGlobal(CURRENT_ROUTE, data.route);
      makeGlobal(TABBAR, data.tabBar);
      makeGlobal(
        CAN_NAVIGATE_TO,
        data.canNavigateTo !== undefined ? data.canNavigateTo : true
      );
    });
    publish(CUSTOM_EVENT.GET_CURRENT_ROUTE);
  } catch (error) {}
}
